<template>
  <div
    id="wrapper"
    class="wrapper"
  >
    <van-list
      v-model:loading="loading"
      class="list"
      :finished="finished"
      loading-text="加载中"
      @load="onLoad"
    >
      <div
        class="item-list"
        v-if="contents && contents.length > 0"
      >
        <div
          v-for="(item, index) in contents"
          :key="index"
          class="item"
        >
          <div class="user_msg">
            <van-image
              class="user_msg_icon"
              fit="cover"
              round
              :src="item.head"
              width="36"
              height="36"
              @click.stop="toHomePage(item.home_page_url)"
            />
            <div class="user_msg_right">
              <div class="user_msg_title">
                <div class="line-1 user_msg_title_name">
                  <span class="line-1 user_msg_title_name_span">
                    {{ item.nick_name }}</span
                  >
                  <span class="user_msg_title_date">{{
                    item.create_time
                  }}</span>
                </div>
              </div>
              <div
                class="user_msg_date"
                v-if="!unPersonal"
              >
                <van-tag
                  :color="item.status == 0 ? '#FF0000' : '#478AFF'"
                  plain
                  >{{ item.status_text }}</van-tag
                >
              </div>
            </div>
          </div>
          <div class="content line-2">
            <van-text-ellipsis
              rows="2"
              :content="item.content"
              expand-text="展开"
              collapse-text="收起"
            />
          </div>
          <div class="info_title_box">
            <div
              class="info_title_tip"
              @click="toDetail(item)"
            >
              <span>原文</span>
            </div>
            <div
              class="info_title line-1"
              @click="toDetail(item)"
            >
              {{ item.title }}
            </div>
          </div>
          <div
            class="common-item-reply"
            v-if="item.sub_comments && item.sub_comments.length > 0"
          >
            <div
              class="common-item-reply-item"
              v-for="(sub_item, sub_index) in item.sub_comments"
              :key="sub_index"
            >
              <div
                class="common-item-reply-content"
                @click="handleComment(item, sub_item)"
              >
                <span v-if="sub_item.reply_nick_name"
                  ><span
                    class="common-item-nick-name"
                    @click.stop="toHomePage(sub_item.home_page_url)"
                    >{{ sub_item.nick_name }}</span
                  >回复<span
                    class="common-item-reply-reply-name"
                    @click="toHomePage(sub_item.reply_home_page_url)"
                    >{{ sub_item.reply_nick_name }}</span
                  >：</span
                >
                <span
                  v-else
                  class="common-item-nick-name"
                  @click.stop="toHomePage(sub_item.home_page_url)"
                  >{{ sub_item.nick_name }}：</span
                >{{ sub_item.content }}
              </div>
              <div class="common-item-reply-bottom">
                <div class="common-item-reply-date">
                  {{ sub_item.create_time }}
                </div>
                <div class="common-item-reply-right">
                  <div
                    v-if="!sub_item.is_me"
                    class="common-item-reply-submit"
                    @click="comment(sub_item)"
                  >
                    回复
                  </div>
                  <div class="common-item-reply-item-like">
                    <van-icon
                      @click="handleLike(sub_item)"
                      class="common-item-reply-item-like-icon"
                      :name="!sub_item.is_like ? 'like-o' : 'like'"
                      :color="!sub_item.is_like ? '#767677' : '#FF3333'"
                      size="18"
                    />
                    <div
                      class="like-num"
                      v-if="sub_item.like_num > 0"
                    >
                      {{ sub_item.like_num }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <van-cell v-if="contents.length == 0">
        <van-empty description="暂无内容" />
      </van-cell>
    </van-list>
  </div>
  <CommentForm
    v-model:show="showForm"
    :selected-item="selectedItem"
  />

  <!-- </van-pull-refresh> -->
</template>

<script>
import {
  Image as VanImage,
  Empty as VanEmpty,
  Cell as VanCell,
  List as VanList,
  Tag as VanTag,
  Icon as VanIcon,
  TextEllipsis as VanTextEllipsis
} from "vant";
import Api from "../api";
import CommentForm from "@/components/CommentForm.vue";
import { useRoute, useRouter } from "vue-router";
import { ref, onMounted } from "vue";
import { Toast } from "@vant/compat";
import Cookies from "js-cookie";
import { triggerLogin } from "@/utils/triggerLogin";
export default {
  components: {
    VanImage,
    VanEmpty,
    VanCell,
    VanList,
    VanTag,
    VanIcon,
    CommentForm,
    VanTextEllipsis
  },
  // eslint-disable-next-line vue/require-default-prop
  props: {
    current_journal: {},
    unPersonal: {
      type: Boolean,
      default: true
    }
  },
  emits: ["setUser"],
  setup(props, context) {
    const contents = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const showForm = ref(false);
    const selectedItem = ref({});
    const route = useRoute();
    const router = useRouter();

    const page = ref(1);
    const onLoad = () => {
      if (route.params.id) {
        getCommentList();
      } else {
        getMyCommentList();
      }
    };

    const comment = (item) => {
      selectedItem.value = item;
      showForm.value = true;
    };

    //获取我的评论
    const getMyCommentList = () => {
      loading.value = true;
      Api.getMyCommentList({ page_size: 20, page: page.value }).then((res) => {
        console.log("返回", res.data.user);

        if (page.value == 1) {
          contents.value = [];
        }
        if (res.data.list.length > 0) {
          page.value++;
          contents.value = contents.value.concat(res.data.list);
        }
        // 数据全部加载完成
        if (res.data.list.length < 20) {
          finished.value = true;
        }
        loading.value = false;
        context.emit("setUser", res.data.user);
      });
    };
    //获取个人评论
    const getCommentList = () => {
      loading.value = true;
      Api.getHomepageCommentList({
        page_size: 20,
        page: page.value,
        user_id: route.params.id
      }).then((res) => {
        console.log("返回", res.data.user);
        if (page.value == 1) {
          contents.value = [];
        }
        if (res.data.list.length > 0) {
          page.value++;
          contents.value = contents.value.concat(res.data.list);
        }
        // 数据全部加载完成
        if (res.data.list.length < 20) {
          finished.value = true;
        }
        loading.value = false;
        context.emit("setUser", res.data.user);
      });
    };
    const toDetail = (item) => {
      if (item.info_url) {
        const userAgentString = navigator.userAgent.toLowerCase();
        if (userAgentString.indexOf("zsrbapp") >= 0) {
          window.ZsrbApp.call("viewInfo", {
            type: 0,
            id: item.info_id,
            title: item.title,
            img: "",
            summary: "",
            url: item.info_url,
            isComment: item.is_comment || 0,
            commentCount: 0
          });
        } else if (userAgentString.indexOf("micromessenger") >= 0) {
          window.open(item.info_url, "_blank");
        }
      }
    };

    const handleLike = (item) => {
      const userAgentString = navigator.userAgent.toLowerCase();
      const isApp = userAgentString.indexOf("zsrbapp") >= 0;
      const sessionToken = sessionStorage.getItem("session_token");
      if (!sessionToken && isApp) {
        console.log("=======执行这里55555");
        triggerLogin();
        return;
      }
      Api.postLike(item.id).then((res) => {
        console.log("handleLike", res);
        if (res.code == 1) {
          item.is_like = !item.is_like;
          item.like_num = item.like_num + (!item.is_like ? -1 : 1);
        } else {
          Toast.fail(res.message || "操作失败");
        }
      });
    };

    const toHomePage = (url) => {
      const userAgentString = navigator.userAgent.toLowerCase();
      if (url) {
        if (userAgentString.indexOf("zsrbapp") >= 0) {
          window.ZsrbApp.call("viewInfo", {
            type: "",
            id: "",
            title: "",
            img: "",
            summary: "",
            url,
            isComment: 0,
            commentCount: 0
          });
        } else if (userAgentString.indexOf("micromessenger") >= 0) {
          window.open(url, "_blank");
        }
      }
    };

    onMounted(() => {});

    return {
      contents,
      loading,
      finished,
      toDetail,
      showForm,
      comment,
      selectedItem,
      handleLike,
      onLoad,
      toHomePage
    };
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  margin: 0 16px;
  position: relative;
  z-index: 1;
  background: #fff;
  border-radius: 10px;
  padding-bottom: 30px;
}
.line-3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -moz-box;
  -moz-line-clamp: 3;
  -moz-box-orient: vertical;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
}

.list {
  padding: 0 16px 10px;

  .item-list {
    .current_journal_title {
      display: flex;
      align-items: center;
      color: #ff4e4e;
      font-size: 18px;
      font-weight: 700;

      &_icon {
        margin-right: 8px;
      }
    }

    .item {
      padding: 14px 0 12px;
      border-bottom: 1px solid #ececec;

      .user_msg {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        &_icon {
          margin-right: 10px;
          min-width: 36px;
          min-height: 36px;
        }
        &_right {
          width: 100%;
          display: flex;
          justify-content: space-between;
        }
        &_title {
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #6d6d6d;
          &_name {
            max-width: 180px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            font-size: 14px;
            color: #6d6d6d;
            &_span {
              display: block;
              max-width: 180px;
            }
          }
          &_date {
            font-size: 12px;
            color: #c0c4cc;
          }
          &_red {
            color: #ffe49b;
            font-size: 10px;
            margin-left: 9px;
            padding: 3px 6px;
            background-color: #ff444c;
            box-shadow: 0pt 1px 3px 0pt rgba(255, 68, 76, 0.37);
            border: 1px solid #ffefc4;
            border-radius: 19px;
          }
        }

        &_date {
          font-size: 16px;
          display: flex;
          align-items: center;
        }
      }

      .content {
        margin-bottom: 10px;
        font-size: 16px;
        color: #2a2a2a;
        :deep(.van-text-ellipsis__action) {
          font-size: 14px;
        }
      }
    }

    .item:last-child {
      border-bottom: none;
    }
  }
}

.info_title_box {
  display: flex;
  align-items: center;
  background: rgba(227, 233, 255, 0.3);
  padding: 12px 10px;
  border-radius: 6px;
  .info_title {
    font-size: 14px;
    color: #848484;
    text-align: left;
  }

  .info_title_tip {
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    color: #ff5c5c;
    background: #ffe5e3;
    font-size: 12px;
    width: 35px;
    height: 20px;
    border-radius: 4px;
    margin-right: 6px;
    span {
      display: inline-block;
    }
  }

  .to_link {
    font-size: 14px;
    color: #1d89ff;
  }
}

.line-1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}

.common-item-reply {
  background-color: #f8f8f8;
  border-radius: 8pt;
  padding: 12px 14px;
  margin-top: 13px;
  .common-item-reply-item {
    padding: 0 0;
    border-bottom: 1px solid #e4e7ed;
    .common-item-reply-item-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      .common-item-reply-item-header-left {
        display: flex;
        align-items: center;
        .common-item-reply-item-header-img {
          width: 25px;
          height: 25px;
          margin-right: 9px;
        }
        .common-item-reply-item-header-name {
          color: #6d6d6d;
          font-size: 14px;
        }
      }
      .common-item-reply-item-like {
        display: flex;
        align-items: center;
        .like-num {
          margin-left: 7px;
          color: #2a2a2a;
          font-size: 12px;
        }
      }
    }
    .common-item-reply-content {
      color: #2a2a2a;
      font-size: 16px;
      text-align: left;
      margin-bottom: 13px;
      line-height: 1.5;
      .common-item-reply-reply-name {
        color: #1d89ff;
      }
      .common-item-nick-name {
        color: #1d89ff;
      }
    }
    .common-item-reply-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .common-item-reply-date {
        color: #c0c4cc;
        font-size: 12px;
      }
      .common-item-reply-right {
        display: flex;
        .common-item-reply-item-like {
          display: flex;
          align-items: center;
          margin-left: 8px;
          .like-num {
            margin-left: 7px;
            color: #2a2a2a;
            font-size: 12px;
          }
        }
      }
      .common-item-reply-submit {
        color: #101010;
        font-size: 14px;
        height: 20px;
        line-height: 22px;
        padding: 0 10px;
        background: #ecf0ff;
        border-radius: 9px;
      }
    }
  }
  .common-item-reply-item:last-child {
    border-bottom: none;
  }
}
</style>
